<div class="conexao-item">
    <h3>{{data.bairro}}</h3>
    <div class="content">
        <div class="item">
            <strong>Líder: </strong><span>{{data.lider}}</span>
        </div>
        <div class="item" *ngIf="data.whatsapp_ativo" (click)="_open()">
            <strong>WhatsApp: </strong>
            <span class="whatsapp">
                <i class="material-icons">whatsapp</i>
                {{data.whatsapp}}
            </span>
        </div>
        <div class="item">
            <strong>Horário: </strong><span>{{data.horario}}h</span>
        </div>
        <div class="item">
            <strong>Perfil: </strong><span>{{data.perfil}}</span>
        </div>
        <div class="item">
            <strong>Endereço:</strong>
            <span>
                {{data.endereco}}, {{data.bairro}} - {{data.cidade}} / {{data.sigla}}
            </span>
        </div>  
        <div class="content-mapa" *ngIf="data.mapa_ativo">
            <div class="mapa" [innerHtml]="data.mapa | safeHtml"></div>
        </div>    
    </div>    
</div>    